@if (form) {
  <div
    class="ui-filter h-full"
    [ngClass]="{
      'ml-2': insideFields?.length,
      'ui-filter-flex': !templateColumns,
    }"
  >
    @if (insideFields?.length) {
      <div class="ui-filter-button">
        <div class="flex items-end relative">
          <hard-button
            class="h-full"
            #filterPopoverTrigger="ngbPopover"
            [classBtn]="'hard-btn--icon'"
            [ngbPopover]="filterPopover"
            (shown)="setOpen()"
            (hidden)="open = false"
            [container]="'body'"
            [autoClose]="'outside'"
            [popoverClass]="'o_autocomplete o_autocomplete--filter'"
            [placement]="placement"
            [matBadge]="count"
            [matBadgeHidden]="!count"
            [matBadgeColor]="'accent'"
          >
            <span class="icon-filter"></span>
          </hard-button>
        </div>

        @if (insideFields?.length && outsideFields?.length) {
          <div class="header-divider ml-2"></div>
        }
      </div>
    }

    @if (outsideFields?.length) {
      <hard-form-grid
        class="w-full"
        [config]="{
          params: {
            direction: 'row',
            fields: outsideFields,
            templateColumns: templateColumns,
          },
        }"
        [form]="form"
      ></hard-form-grid>

      @if (showClearIconButton) {
        <hard-button
          class="ml-2"
          [type]="'neutral'"
          [classBtn]="'hard-btn--icon'"
          (click)="clear()"
          [ngbTooltip]="'showCase.reset' | hardTranslate"
          [container]="'body'"
          [triggers]="'hover'"
        >
          <span class="icon-clear"></span>
        </hard-button>
      }
      @if (showClearTextButton) {
        <hard-button
          class="ml-2"
          (click)="clear()"
        >
          {{ "showCase.reset" | hardTranslate }}
        </hard-button>
      }
    }
  </div>
}

<ng-template #filterPopover>
  <ui-filter-dialog
    [fields]="insideFields"
    [form]="form"
    (clearEmit)="clear()"
    (searchEmit)="search()"
    (closeEmit)="close()"
    [hideResetBtn]="resetFiltersOnClear"
    [popoverCssClass]="popoverCssClass"
  ></ui-filter-dialog>
</ng-template>
